<template>
  <div class="client-grade">
    <second-menu-link-content>
      <template v-slot:header>
        <span>客户等级</span>
      </template>
      <template v-slot:content>
        <div class="client-grade-main">
          <div class="add-client-grade">
            <el-button class="btn-blue" @click="add">新增</el-button>
            <span class="text">客户等级数量最多为5个</span>
            <el-dialog title="新增客户等级" :visible.sync="dialogVisible" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="等级名称：" prop="name">
                  <el-input v-model="ruleForm.name" class="gray" placeholder="请输入等级名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="等级折扣：" prop="discount">
                  <el-input
                    type="age"
                    v-model.number="ruleForm.discount"
                    class="gray"
                    placeholder="请输入等级折扣"
                  ></el-input>
                  <span class="symbol">%</span>
                </el-form-item> -->
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="submit('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <div class="table" ref="table">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="name" label="等级名称"></el-table-column>
              <!-- <el-table-column prop="discount" label="等级折扣">
                <template slot-scope="scope">
                  <span>{{scope.row.discount}}</span>
                  <span>%</span>
                </template>
              </el-table-column> -->
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="change(scope.row,scope.$index )"
                  >修改</el-button>
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="remove(scope.row.id, scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog title="新增客户等级" :visible.sync="dialogVisible2" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm2"
                :rules="rules"
                ref="ruleForm2"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="等级名称：" prop="name">
                  <el-input v-model="ruleForm2.name" class="gray" placeholder="请输入等级名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="等级折扣：" prop="discount">
                  <el-input v-model.number="ruleForm2.discount" class="gray" placeholder="请输入等级折扣"></el-input>
                  <span class="symbol">%</span>
                </el-form-item> -->
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm2')">取消</el-button>
                  <el-button class="btn-blue" @click="save('ruleForm2')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBClient from "models/db/client.js";
const dbClient = new DBClient();
export default {
  data() {
    return {
      tableData: [],
      ruleForm: {
        name: "",
        // discount: ""
      },
      ruleForm2: "",
      rules: {
        name: [{ required: true, message: "请输入等级名称", trigger: "blur" }],
        // discount: [
        //   { required: true, message: "请输入等级折扣", trigger: "blur" },
        //   { min: 1, type: "number", message: "折扣必须为正整数" }
        // ]
      },
      loading: true,
      dialogVisible: false,
      dialogVisible2: false,
      index: ""
    };
  },
  components: {
    SecondMenuLinkContent
  },
  created() {
    this.getGradeListData();
  },
  methods: {
    // 获取等级列表
    getGradeListData() {
      dbClient.getClientGradeList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            // obj.discount = value.rebate;
            arr.push(obj);
          });
          this.tableData = arr;
          this.loading = false;
        }
      });
    },
    // 点击添加按钮
    add() {
      this.dialogVisible = true;
    },
    // 重置
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    // 保存添加
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let name = this.ruleForm.name;
          // let rebate = this.ruleForm.discount;
          let data = {
            name,
            // rebate
          };
          dbClient.postAddClientGrade(data).then(res => {
            if (res.success) {
              this.reset("ruleForm");
              this.getGradeListData();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除客服
    remove(id, index) {
      this.$confirm(`是否确认删除该等级`, "删除等级", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          dbClient.getDeleteClientGrade(id).then(res => {
            if (res.success) {
              this.tableData.splice(index, 1);
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 修改客服
    change(row, index) {
      this.dialogVisible2 = true;
      this.ruleForm2 = JSON.parse(JSON.stringify(row));
    },
    // 保存修改
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.ruleForm2.id;
          let name = this.ruleForm2.name;
          // let rebate = this.ruleForm2.discount;
          let data = {
            id,
            name,
            // rebate
          };
          dbClient.postUpdateClientGrade(data).then(res => {
            if (res.success) {
              this.getGradeListData();
              this.dialogVisible2 = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.client-grade {
  width: 100%;
  height: 100%;
  .client-grade-main {
    .add-client-grade {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-end;
      .el-button {
        width: 96px;
        margin-right: 16px;
      }
      .text {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
<style lang="scss">
.client-grade {
  .client-grade-main {
    .el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0 24px;
        line-height: 48px;
        color: #606266;
        font-family: "PingFangSC-Medium";
        letter-spacing: 1px;
        .el-dialog__title {
          font-size: 16px;
          color: #606266;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0px 16px 16px 16px;
        .border {
          border-bottom: 1px solid #f7f7f7;
          margin-bottom: 16px;
        }
        .el-form {
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
          .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
              line-height: 32px;
            }
            .el-form-item__content {
              line-height: 32px;
              display: flex;
              .symbol {
                display: inline-block;
                width: 32px;
                height: 32px;
                background: rgba(201, 201, 201, 1);
                color: #fff;
                line-height: 32px;
                text-align: center;
                border-radius: 2px;
              }
              .el-form-item__error {
                padding-top: 2px;
              }
              .el-button {
                width: 96px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
